import { useZustand } from '../../hooks/useZustand'
import { hasActiveFilters } from '../StatementFilterPanel/filterStatements'

/**
 * As graph & analytics panel are still not part of react and uses old ejs code
 * we need to emit events to update the graph.
 * So these are modules responsible executing side effects on any filter change
 */
export const handleCombinedFilters = (
    newFilters,
    prevFilters,
    filteredStatements
) => {
    const activeFilters = {
        topics: newFilters.topics.length > 0,
        sentiments: newFilters.sentiments.length > 0,
        tags: newFilters.tags.length > 0,
    }

    const isAnyFilterActive = hasActiveFilters(newFilters)

    const label = useZustand.getState().currentContext
    const sentimentsChanged = !arraysAreEqual(
        newFilters.sentiments,
        prevFilters.sentiments
    )
    const currentSentimentMode = useZustand.getState().currentSentimentMode

    if (!window.graph) {
        console.error('No graph available, Not possible to update graph')
        return
    }

    // Select all entries
    if (!isAnyFilterActive) {
        if (!label) {
            console.error('No label available')
            return newFilters
        }

        analyticsPanel.analyzeSentiment(
            null,
            label,
            null,
            'recalculate',
            currentSentimentMode
        )

        if (sentimentsChanged) {
            emitEvent('sentimentFilterUpdate', [])
            window.highlightedSentiment = []
        }

        const allIds = Object.values(useZustand.getState().statements)
            .flatMap(statements => statements)
            .map(({ uid }) => uid.toString())
        graph().selectEntries(allIds, 'tagfilter', false)
        return
    }

    let filteredStatementIds = filteredStatements.map(({ uid }) =>
        uid.toString()
    )

    if (activeFilters.sentiments) {
        // highlight sentiment in analytics
        emitEvent('sentimentFilterUpdate', [...newFilters.sentiments])
        window.highlightedSentiment = [...newFilters.sentiments]
    }

    if (sentimentsChanged) {
        console.log('Sentiment filter changed')
        emitEvent('sentimentFilterUpdate', [...newFilters.sentiments])
        window.highlightedSentiment = [...newFilters.sentiments]
    }

    graph().selectEntries(filteredStatementIds, 'tagfilter', false)
    analyticsPanel.analyzeSentiment(
        null,
        label,
        filteredStatementIds.map(parseInt),
        'recalculate',
        currentSentimentMode
    )

    // graph().deleteNodes(nodesToDelete, graph().updateMetrics)
    return newFilters
}

const arraysAreEqual = (arr1, arr2) => {
    if (arr1.length !== arr2.length) return false
    const sortedArr1 = [...arr1].sort()
    const sortedArr2 = [...arr2].sort()
    return sortedArr1.every((value, index) => value === sortedArr2[index])
}

// Event emitter utility functions
const emitEvent = (eventName, data) => {
    if (window.myEventEmitter && myEventEmitter._events[eventName]) {
        myEventEmitter.emit(eventName, data)
    }
}
